import React from 'react';
import {
  HeroSection,
  CompanyOverviewBanner,
  ServicesBentoGrid,
  ValuePillarsSection,
  DoctorTerraCaseStudy,
  PortfolioShowcase,
  ProposalEstimatorWidget,
  ServicesDetailSection,
  AboutSection,
  ContactSection,
} from '../components/sections';

export interface HomeProps {
  onOpenConsultation: () => void;
}

export const Home: React.FC<HomeProps> = ({ onOpenConsultation }) => {
  return (
    <main className="space-y-0">
      <HeroSection
        onOpenConsultation={onOpenConsultation}
        onExploreServices={() => {
          const elem = document.getElementById('services');
          elem?.scrollIntoView({ behavior: 'smooth' });
        }}
      />
      <CompanyOverviewBanner />
      <ServicesBentoGrid onSelectService={() => onOpenConsultation()} />
      <DoctorTerraCaseStudy onOpenConsultation={onOpenConsultation} />
      <ValuePillarsSection />
      <PortfolioShowcase onOpenConsultation={onOpenConsultation} />
      <ProposalEstimatorWidget />
      <ServicesDetailSection onOpenConsultation={onOpenConsultation} />
      <AboutSection />
      <ContactSection onOpenConsultation={onOpenConsultation} />
    </main>
  );
};
